

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label?: string;
    error?: string;
}

export function Input({ label, error, className = '', ...props }: InputProps) {
    return (
        <div className="flex flex-col gap-sm">
            {label && (
                <label className="text-sm font-medium" style={{ color: 'var(--color-text-secondary)' }}>
                    {label}
                </label>
            )}
            <input
                className={className}
                {...props}
            />
            {error && (
                <span className="text-sm" style={{ color: 'var(--color-error)' }}>
                    {error}
                </span>
            )}
        </div>
    );
}
